import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { COLLECTIONS, allowlistDocId } from './firestore-schema';

/**
 * Check if an email is in the agent allowlist (strict match).
 * @param {string} email
 * @returns {Promise<boolean>}
 */
export async function isEmailAllowed(email) {
  if (!db || !email) return false;
  const id = allowlistDocId(email);
  const ref = doc(db, COLLECTIONS.ALLOWLIST, id);
  const snap = await getDoc(ref);
  return snap.exists();
}
